import { render, staticRenderFns } from "./SubjectModal.vue?vue&type=template&id=8b3749ce&scoped=true"
import script from "./SubjectModal.vue?vue&type=script&lang=js"
export * from "./SubjectModal.vue?vue&type=script&lang=js"
import style0 from "./SubjectModal.vue?vue&type=style&index=0&id=8b3749ce&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3749ce",
  null
  
)

export default component.exports